import Auth from '@aws-amplify/auth';
import { useState } from 'react';

export const useChangePassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const changePassword = async (oldPassword: string, newPassword: string) => {
    setIsLoading(true);
    setError(null);

    try {
      const me = await Auth.currentAuthenticatedUser();
      const data = await Auth.changePassword(me, oldPassword, newPassword);
      setIsLoading(false);
      return data === 'SUCCESS';
    } catch (err) {
      setIsLoading(false);
      if (err.code && err.code === 'NotAuthorizedException') {
        let merr = new Error(err);
        merr.message = 'Incorrect password';
        setError(merr);
        return;
      }
      setError(err);
    }
  };

  return { isLoading, error, setError, changePassword };
};
